<div (click)="handleAction($event)" class="flex flex-col gap-2 cursor-default">
    @if (label() && mode() !== "button") {
        <app-label [required]="required()" [size]="size()">{{
            label()
        }}</app-label>
    }
    <div (clickOutside)="open.set(false)" class="flex relative flex-col gap-1">
        @if (mode() === "button") {
            <app-button
                variant="outline"
                [color]="value() ? 'primary' : 'gray'"
            >
                <p class="text-sm">{{ label() }}</p>
                @if (inputValue(); as value) {
                    <p class="text-sm">{{ value }}</p>
                }
            </app-button>
        } @else {
            <app-input
                [size]="size()"
                (keyup)="handleKeyup($event)"
                (valueChange)="handleSearch($event)"
                [(value)]="inputValue"
                [readonly]="!search() || isMobile()!"
                [placeholder]="placeholder()"
                [debounce]="search() ? 300 : 0"
                [suffixIcon]="suffixIcon() || 'ic:baseline-keyboard-arrow-down'"
                [prefixIcon]="prefixIcon()"
                [disabled]="disabled()"
            />
        }
        @if (open() && options().length > 0) {
            <div
                #menuWrapper
                [class.invisible]="!menuRender()"
                class="z-[9999] bg-white menu-wrapper theme-wrapper theme-border"
            >
                @for (option of options(); track option) {
                    <app-select-option
                        (customEvent)="handleCustomEvent($event)"
                        (select)="handleSelect($event)"
                        (mouseEnter)="currentIndex.set($index)"
                        (mouseLeave)="currentIndex.set(-1)"
                        [option]="option"
                        [focus]="currentIndex() === $index"
                        [renderItem]="renderItem()"
                        [bindLabel]="bindLabel()!"
                        [bindValue]="bindValue()!"
                    />
                }
            </div>
        }
    </div>
</div>
